var _defs, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-gradient",
    cx: "50%",
    cy: "50%",
    r: "70%",
    fx: "50%",
    fy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f0f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d6eaff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "megaphone-glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3498db",
    floodOpacity: 0.3,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color",
    in2: "blur",
    operator: "in",
    result: "glow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "glow",
    operator: "over"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "target-glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2c3e50",
    floodOpacity: 0.2,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color",
    in2: "blur",
    operator: "in",
    result: "glow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "glow",
    operator: "over"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "megaphone-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3498db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2980b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "funnel-gradient-1",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3498db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2980b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "funnel-gradient-2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9b59b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8e44ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "funnel-gradient-3",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2ecc71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#27ae60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "funnel-gradient-4",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e74c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c0392b"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 50,
    fill: "url(#bg-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 40)",
    filter: "url(#megaphone-glow)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "25,40; 24,39; 25,40",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L30,10 L30,30 L0,20 Z",
    fill: "url(#megaphone-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 10,
    fill: "url(#megaphone-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 17,
    width: 10,
    height: 6,
    rx: 2,
    fill: "#2c3e50"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65,40 Q75,30 85,40",
    stroke: "#3498db",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;1;0.5",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65,40 Q75,50 85,40",
    stroke: "#3498db",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;1;0.5",
    dur: "1s",
    begin: "0.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70,35 Q85,20 100,35",
    stroke: "#3498db",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "2,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M70,35 Q85,20 100,35; M69,34 Q84,18 101,34; M70,35 Q85,20 100,35",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;10",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,45 Q85,60 100,45",
    stroke: "#3498db",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "2,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M70,45 Q85,60 100,45; M69,46 Q84,62 101,46; M70,45 Q85,60 100,45",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;10",
    dur: "2s",
    repeatCount: "indefinite"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(85, 40)",
    filter: "url(#target-glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "none",
    stroke: "#2c3e50",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "14;15;14",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 10,
    fill: "none",
    stroke: "#2c3e50",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "9;10;9",
    dur: "3s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#2c3e50"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;5;4",
    dur: "3s",
    begin: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.8;1;0.8",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: -18,
    y1: 0,
    x2: 18,
    y2: 0,
    stroke: "#2c3e50",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.7;1;0.7",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -18,
    x2: 0,
    y2: 18,
    stroke: "#2c3e50",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.7;1;0.7",
    dur: "2.5s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Q10,-5 20,0 Q25,10 20,20 Q10,25 0,20 Q-5,10 0,0 Z",
    fill: "#2c3e50"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.9;1;0.9",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5,5 Q10,0 15,5 M5,15 Q10,20 15,15 M5,5 Q0,10 5,15 M15,5 Q20,10 15,15",
    stroke: "#3498db",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.7;1;0.7",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 1,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0.8;1.2;0.8",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 8,
    r: 1,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0.8;1.2;0.8",
    dur: "2s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7,12 Q10,14 13,12",
    stroke: "#3498db",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M7,12 Q10,14 13,12; M7,13 Q10,15 13,13; M7,12 Q10,14 13,12",
    dur: "4s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L0,20",
    stroke: "#2c3e50",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0,20 L0,20; M0,20 L10,15; M0,20 L10,15 L20,18; M0,20 L10,15 L20,18 L30,10; M0,20 L10,15 L20,18 L30,10 L40,5; M0,20 L10,15 L20,18 L30,10 L40,5 L50,0",
    dur: "3s",
    begin: "0.5s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 20,
    r: 0,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;2;2",
    dur: "0.3s",
    begin: "0.5s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15,
    r: 0,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;2;2",
    dur: "0.3s",
    begin: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 0,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;2;2",
    dur: "0.3s",
    begin: "1.5s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 0,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;2;2",
    dur: "0.3s",
    begin: "2s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 5,
    r: 0,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;2;2",
    dur: "0.3s",
    begin: "2.5s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 0,
    r: 0,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;2;2",
    dur: "0.3s",
    begin: "3s",
    fill: "freeze"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85, 70)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.7;5;4.7",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.9;1;0.9",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 2,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 6,
    fill: "white"
  }, "f")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 75)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.7;5;4.7",
    dur: "2s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.9;1;0.9",
    dur: "2s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 2,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 6,
    fill: "white"
  }, "in")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92, 90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4.7;5;4.7",
    dur: "2s",
    begin: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.9;1;0.9",
    dur: "2s",
    begin: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 2,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 8,
    fill: "white"
  }, "t")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 1,
    fill: "#3498db",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M55,40 C65,30 75,25 85,25",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 1,
    fill: "#3498db",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M55,40 C65,50 75,55 85,55",
    dur: "2.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 1,
    fill: "#3498db",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M85,40 C90,50 95,60 92,90",
    dur: "3s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "hover-graph",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 100,
    height: 75,
    rx: 5,
    fill: "rgba(255,255,255,0.9)",
    stroke: "#3498db",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 22,
    fontFamily: "Arial",
    fontSize: 6.5,
    fontWeight: "bold",
    fill: "#2c3e50",
    textAnchor: "middle"
  }, "\n      AI-Powered Marketing Funnel\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 47) scale(0.80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30,-20 L30,-20 L25,0 L-25,0 Z",
    fill: "url(#funnel-gradient-1)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9",
    dur: "0.5s",
    begin: "0s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-25,2 L25,2 L20,20 L-20,20 Z",
    fill: "url(#funnel-gradient-2)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9",
    dur: "0.5s",
    begin: "0.5s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-20,22 L20,22 L15,35 L-15,35 Z",
    fill: "url(#funnel-gradient-3)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9",
    dur: "0.5s",
    begin: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-15,37 L15,37 L10,45 L-10,45 Z",
    fill: "url(#funnel-gradient-4)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9",
    dur: "0.5s",
    begin: "1.5s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial",
    fontSize: 5,
    fill: "white",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -10,
    textAnchor: "middle"
  }, "AWARENESS"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 11,
    textAnchor: "middle"
  }, "INTEREST"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 28.5,
    textAnchor: "middle"
  }, "DECISION"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 41,
    textAnchor: "middle"
  }, "ACTION")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: -15,
    r: 2,
    fill: "#2c3e50"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "-15;41",
    dur: "3s",
    begin: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "-15;-5",
    dur: "3s",
    begin: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 2,
    fill: "#2c3e50"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "-15;41",
    dur: "3s",
    begin: "2.3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "0;0",
    dur: "3s",
    begin: "2.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -15,
    r: 2,
    fill: "#2c3e50"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "-15;41",
    dur: "3s",
    begin: "2.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "15;5",
    dur: "3s",
    begin: "2.6s",
    repeatCount: "indefinite"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.26416dcf30d015acef1c52bda8ee87e5.svg";
export { ForwardRef as ReactComponent };